import Stat from './StatV2'
import './StatList.scoped.scss'

export default function StatList({ stats }) {
  return <div className="stat-list">
    {stats.map((stat, index) => <div key={index}><Stat key={index} {...stat} /></div>)}
  </div>
}

